// extracted by mini-css-extract-plugin
export var boldText = "_80-4";
export var checkboxContainer = "_80-6";
export var closeIcon = "_80-i";
export var container = "_80-0";
export var drawer = "_80-8";
export var drawerContent = "_80-9";
export var extraSmallText = "_80-5";
export var fulfillmentGroupTable = "_80-e";
export var largeText = "_80-3";
export var loadingSpinnerContainer = "_80-j";
export var mediumText = "_80-2";
export var narrow = "_80-f";
export var notificationLink = "_80-l";
export var packageCheckIconContainer = "_80-7";
export var slideoutHeaderActions = "_80-g";
export var slideoutHeaderActionsShifted = "_80-h";
export var slideoutHeaderContainer = "_80-a";
export var slideoutModal = "_80-c";
export var stickyHeaderWrapper = "_80-b";
export var table = "_80-k";
export var tableContainer = "_80-d";
export var tertiaryText = "_80-1";